import { lazy } from 'react';
import { SidebarLayout } from '@trukt/ui/SidebarLayout';
import { PageTitle } from '@trukt/ui/PageTitle';
import { RouteObject } from 'react-router-dom';

import { PATH_NAMES } from '../../shared';
import { SidebarContainer } from '../../components';
import { ORDER_STATUS_MAP } from '@trukt/utils/OrderStatusMap';

const OrderListView = lazy(() => import('../../OrderListView'));

export const ORDER_LIST_ROUTES: RouteObject[] = [
  {
    path: PATH_NAMES.ROOT,
    element: (
      <PageTitle>
        <SidebarLayout sidebar={<SidebarContainer />} />
      </PageTitle>
    ),
    children: [
      {
        path: PATH_NAMES.ROOT,
        element: <OrderListView status={ORDER_STATUS_MAP.ALL} key={PATH_NAMES.ROOT} />,
      },
      {
        path: PATH_NAMES.orderListView.SUBMITTED,
        element: (
          <OrderListView
            status={ORDER_STATUS_MAP.SUBMITTED}
            key={PATH_NAMES.orderListView.SUBMITTED}
          />
        ),
      },
      {
        path: PATH_NAMES.orderListView.ON_HOLD,
        element: (
          <OrderListView status={ORDER_STATUS_MAP.ON_HOLD} key={PATH_NAMES.orderListView.ON_HOLD} />
        ),
      },
      {
        path: PATH_NAMES.orderListView.SCHEDULED,
        element: (
          <OrderListView
            status={ORDER_STATUS_MAP.SCHEDULED}
            key={PATH_NAMES.orderListView.SCHEDULED}
          />
        ),
      },
      {
        path: PATH_NAMES.orderListView.PICKED_UP,
        element: (
          <OrderListView
            status={ORDER_STATUS_MAP.PICKED_UP}
            key={PATH_NAMES.orderListView.PICKED_UP}
          />
        ),
      },
      {
        path: PATH_NAMES.orderListView.DELIVERED,
        element: (
          <OrderListView
            status={ORDER_STATUS_MAP.DELIVERED}
            key={PATH_NAMES.orderListView.DELIVERED}
          />
        ),
      },
      {
        path: PATH_NAMES.orderListView.CANCELED,
        element: (
          <OrderListView
            status={ORDER_STATUS_MAP.CANCELED}
            key={PATH_NAMES.orderListView.CANCELED}
          />
        ),
      },
    ],
  },
];
